import {CREATE_PROVIDER, GET_PROVIDERS, UPDATE_PROVIDER_STATUS} from './constants';

export function getProvidersAction(payload: object) {
  return {
    type: GET_PROVIDERS,
    payload,
  };
}


export function updateProviderStatus(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_PROVIDER_STATUS,
    payload,
  };
}

export function createProviderAction(payload: object) {
  return {
    type: CREATE_PROVIDER,
    payload,
  };
}
